import { buildHeaders } from "src/utils/apiUtils";



  
let BASE_URL = process.env.REACT_APP_API_URL

export async function loadConfig() {
  // .env is used directly; no encrypted config to load.
}

loadConfig().then(() => {
});


export async function fetchComplianceStatus() {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/admin/compliance-status`, {
        method: 'GET',
        headers,
        credentials: "include",
    });
  
  
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
  }



  export async function fetchSurveyConductedTime () {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/admin/surveys-over-time`, {
        method: 'GET',
        headers,
      credentials: "include",
    });
  
  
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
  }

  export async function getComplianceProgressOverTime () {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/admin/compliance-progress-time`, {
        method: 'GET',
        headers,
      credentials: "include",
    });
  
  
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
  }

  export async function fetchTotalSurveyResponse () {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/admin/total-survey-responses`, {
        method: 'GET',
        headers,
      credentials: "include",
    });
  
  
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
  }


  export async function fetchCountUsersParticipateSurveys () {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/admin/total-survey-participants`, {
        method: 'GET',
        headers,
      credentials: "include",
    });
  
  
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
  }


  export async function fetchTotalCountSurveys () {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/admin/total-surveys`, {
        method: 'GET',
        headers,
      credentials: "include",
    });
  
  
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
  }


  /**
   * Paged + searchable variants of the three survey feeds above, for the
   * dashboard drill-downs. The unsuffixed versions still back the count tiles.
   * All three answer { count, data, totalPages }.
   */
  async function fetchSurveyPage(path: string, { perPage, pageNo, search, sortBy, sortOrder }: {
    perPage: number; pageNo: number; search?: string; sortBy?: string; sortOrder?: 'asc' | 'desc';
  }) {
    try {
      const headers = await buildHeaders(BASE_URL);
      const params = new URLSearchParams({ perPage: String(perPage), pageNo: String(pageNo) });
      if (search) params.set('search', search);
      if (sortBy) params.set('sortBy', sortBy);
      if (sortOrder) params.set('sortOrder', sortOrder);
      const response = await fetch(`${BASE_URL}/admin/${path}?${params.toString()}`, {
        method: 'GET',
        headers,
        credentials: 'include',
      });
      const data = await response.json();
      if (!response.ok) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
      }
      return data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  type SurveyPageArgs = { perPage: number; pageNo: number; search?: string; sortBy?: string; sortOrder?: 'asc' | 'desc' };

  export function fetchTotalSurveyResponsesPage(args: SurveyPageArgs) {
    return fetchSurveyPage('total-survey-responses-page', args);
  }

  export function fetchSurveyParticipantsPage(args: SurveyPageArgs) {
    return fetchSurveyPage('total-survey-participants-page', args);
  }

  export function fetchSurveysPage(args: SurveyPageArgs) {
    return fetchSurveyPage('total-surveys-page', args);
  }

  export async function fetchNumControlPerCompliance () {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/admin/controls-per-compliance`, {
        method: 'GET',
        headers,
      credentials: "include",
    });
  
  
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
  }

  export async function fetchTaskCompletionRate () {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/admin/task-completion-rate`, {
        method: 'GET',
        headers,
      credentials: "include",
    });
  
  
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
  }